import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (e) {
      const d = e?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24">
      <div className="text-mono-label">Admin</div>
      <h1 className="font-display font-black text-4xl mt-3 tracking-tighter">Sign in.</h1>
      <p className="mt-3 text-[#475569] text-sm">Owner / staff access only.</p>

      <form onSubmit={submit} className="mt-10 space-y-5">
        <div>
          <div className="text-mono-label text-[#475569]">Email</div>
          <input data-testid="login-email" required type="email" className="field mt-2" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div>
          <div className="text-mono-label text-[#475569]">Password</div>
          <input data-testid="login-password" required type="password" className="field mt-2" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {err && <div data-testid="login-error" className="text-sm text-red-400 border border-red-900 px-4 py-3">{err}</div>}
        <button data-testid="login-submit" disabled={busy} className="btn-brand w-full justify-center">
          <LogIn className="w-4 h-4" /> {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
